// import React, { useEffect, useState } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import './App.scss';
// import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
// import { publicRoutes, teacherRoutes, studentRoutes } from './router/index';
// import { useAppSelector, useAppDispatch } from './hooks/reducer'; // Імпортуйте ваш хук dispatch
// import Header from './components/Home/Header';
// import Sidebar from './components/Home/Sidebar';
// import axios from 'axios';
// import { fetchUserData, } from './store/slices/auth'; // Імпортуйте екшн для встановлення авторизації
// import { Analytics } from '@vercel/analytics/react';



// const App = () => {
//     const dispatch = useAppDispatch();
//     const user = useAppSelector(state => state.authReducer.data?.user);
//     const isAuth = !!user;
//     const isAdmin = user?.isAdmin; // Перевірка ролі користувача

//     const [sidebarOpen, setSidebarOpen] = useState(false);

//     useEffect(() => {
//         const token = localStorage.getItem('token');
//         if (token) {
//             axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
//             dispatch(fetchUserData());
//         }
//     }, [dispatch]);

//     return (
//         <div className={isAuth ? 'App app_private' : 'App app_public'}>
//             <Analytics />
//             <BrowserRouter>
//                 {!isAuth ? (
//                     <Routes>
//                         {publicRoutes.map(route => (
//                             <Route key={route.path} path={route.path} element={route.element} />
//                         ))}
//                         <Route path="/" element={<Navigate to="/start" />} />
//                         <Route path="*" element={<Navigate to="/start" />} />
//                     </Routes>
//                 ) : (
//                     <div className="flex  w-[100vw] h-[100vh] ">
//                         {/* Sidebar */}
//                         <Sidebar  sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
//                         <div className="flex-1 flex flex-col">
//                             {/* Header */}
//                             <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
//                             {/* Content */}
//                             <div className="flex-1 py-6 px-2 overflow-y-auto">
                            

//                                 <Routes>
//                                     {isAdmin
//                                         ? teacherRoutes.map(route => (
//                                               <Route key={route.path} path={route.path} element={route.element} />
//                                           ))
//                                         : studentRoutes.map(route => (
//                                               <Route key={route.path} path={route.path} element={route.element} />
//                                           ))}
//                                     <Route
//                                         path="/"
//                                         // element={<Navigate to={isAdmin ? '/admin/home' : '/my-courselist'} />}
//                                         element={<Navigate to={isAdmin ? '/my-courselist' : '/my-courselist'} />}
//                                     />
//                                     <Route path="*" element={<Navigate to={isAdmin ? '/my-courselist' : '/my-courselist'} />} />
//                                 </Routes>
//                             </div>
//                         </div>
//                     </div>
//                 )}
//             </BrowserRouter>
//         </div>
//     );
// };

// export default App;


import React, { useEffect, useMemo, useRef, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
  matchPath,
} from 'react-router-dom';
import {
  candidateRoutes,
  publicRoutes,
  teacherRoutes,
  studentRoutes,
} from './router/index';
import { useAppSelector, useAppDispatch } from './hooks/reducer';
import Header from './components/Home/Header';
import Sidebar from './components/Home/Sidebar';
import axios from 'axios';
import { fetchUserData } from './store/slices/auth';
import { Analytics } from '@vercel/analytics/react';
import FloatingConsultationCta from './components/NewView/Common/FloatingConsultationCta';

type PrivateLayoutProps = {
  sidebarOpen: boolean;
  setSidebarOpen: (arg: boolean) => void;
};

const PrivateLayout = ({ sidebarOpen, setSidebarOpen }: PrivateLayoutProps) => {
  const location = useLocation();
  const mainRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const resetScroll = () => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      mainRef.current?.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    };

    resetScroll();
    const frame = window.requestAnimationFrame(resetScroll);
    const timeout = window.setTimeout(resetScroll, 80);

    return () => {
      window.cancelAnimationFrame(frame);
      window.clearTimeout(timeout);
    };
  }, [location.pathname, location.search]);

  return (
    <div className="flex h-[100dvh] w-full overflow-hidden bg-[#F6F7F9]">
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      <div className="flex min-w-0 flex-1 flex-col">
        <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        <main
          ref={mainRef}
          className="min-h-0 flex-1 overflow-y-auto overscroll-contain bg-[#F6F7F9]"
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
};

const AppContent = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();

  const user = useAppSelector((state) => state.authReducer.data?.user);
  const isAuth = !!user;
  const adminRoles = ['admin', 'super_admin', 'education_admin', 'career_manager'];
  const isAdmin = Boolean(
    user?.isAdmin || (user?.role && adminRoles.includes(user.role))
  );
  const adminHomePath =
    user?.role === 'super_admin'
      ? '/admin/users'
      : user?.role === 'career_manager'
      ? '/admin/career'
      : '/admin/calendar';
  const isCandidate = Boolean(
    user && !isAdmin && user.programAccess !== 'active'
  );

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    if (!('scrollRestoration' in window.history)) return;

    const previous = window.history.scrollRestoration;
    window.history.scrollRestoration = 'manual';

    return () => {
      window.history.scrollRestoration = previous;
    };
  }, []);

  const privateRoutes = useMemo(
    () =>
      isAdmin ? teacherRoutes : isCandidate ? candidateRoutes : studentRoutes,
    [isAdmin, isCandidate]
  );

  const homePath = isAdmin
    ? adminHomePath
    : isCandidate
    ? '/application-status'
    : '/calendar';

  // Перевірка токена і отримання юзера
  useEffect(() => {
    let mounted = true;

    const initAuth = async () => {
      const token = localStorage.getItem('token');

      if (token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        try {
          await dispatch(fetchUserData() as any);
        } catch (e) {
          // якщо токен протух — прибираємо
          localStorage.removeItem('token');
          delete axios.defaults.headers.common['Authorization'];
        }
      } else {
        delete axios.defaults.headers.common['Authorization'];
      }

      if (mounted) setAuthChecked(true);
    };

    initAuth();

    return () => {
      mounted = false;
    };
  }, [dispatch]);

  const isPublicPath = publicRoutes.some((r) =>
    matchPath({ path: r.path, end: true }, location.pathname)
  );

  // Визначаємо, чи зараз відкритий приватний маршрут
  const isPrivatePath = privateRoutes.some((r) =>
    matchPath({ path: r.path, end: false }, location.pathname)
  );

  const appClassName = `App ${
    isAuth && isPrivatePath && !isPublicPath ? 'app_private' : 'app_public'
  }`;

  if (!authChecked) {
    return (
      <div className="App app_public">
        <Analytics />
        {/* Можеш вставити тут loader */}
      </div>
    );
  }

  return (
    <div className={appClassName}>
      <Analytics />

      <Routes>
        {/* ПУБЛІЧНІ РОУТИ — ЗАВЖДИ ДОСТУПНІ */}
        {publicRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={route.element} />
        ))}

        {/* ПРИВАТНІ РОУТИ */}
        <Route
          element={
            isAuth ? (
              <PrivateLayout
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
              />
            ) : (
              <Navigate to="/loginn" replace />
            )
          }
        >
          {privateRoutes.map((route) => (
            <Route key={route.path} path={route.path} element={route.element} />
          ))}
        </Route>

        {/* ROOT */}
        <Route
          path="/"
          element={
            <Navigate to="/start" replace />
          }
        />

        {/* FALLBACK */}
        <Route
          path="*"
          element={
            <Navigate to={isAuth ? homePath : '/start'} replace />
          }
        />
      </Routes>

      {isPublicPath && <FloatingConsultationCta />}
    </div>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
};

export default App;
